export default class MegaMenuScrolling {
    constructor() {
        this.navItems = document.querySelectorAll(".jet-mega-menu-item");
    }

    init() {
        document.addEventListener("scroll",( e ) => { this.scrollCheck(); } );
    }

    scrollCheck(){
        let length = this.navItems.length;

        if( window.pageYOffset > 50 && length ){
            for(let i = 0; i < length; i++){
                let e = this.navItems[i];

                if (!e.classList.contains("jet-mega-menu-item--hover")){
                    continue;
                }
                else{
                    e.classList.remove("jet-mega-menu-item--hover");
                    break;
                }
            }
        }
    }
}